import { render, staticRenderFns } from "./layout-widget-shop-reduced.vue?vue&type=template&id=2dd0d88a"
import script from "./layout-widget-shop-reduced.vue?vue&type=script&lang=ts"
export * from "./layout-widget-shop-reduced.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports